import {
	CLIENT,
	CLIENT_INSIGHT,
	FIELDS,
	parseStyleString,
	styleToString,
} from '@/utils/emailHelper';
import { findParentNode } from '@tiptap/core';

export const parentClosestToPos = findParentNode(
	(node) =>
		node?.attrs?.[TEMPLATE_VALUE] ||
		node?.content?.content?.some(
			(n) => n.attrs?.[TEMPLATE_VALUE] || n.marks?.some((m) => m.attrs?.[TEMPLATE_VALUE]),
		),
);

export const TEMPLATE_VALUE = 'template-value';
export const SIGNATURE_VALUE = 'data-signature';

export const TEMPLATE_VALUE_ATTRIBUTE = {
	[TEMPLATE_VALUE]: {
		default: null,
		parseHTML: (element) => element.getAttribute(TEMPLATE_VALUE),
		renderHTML: (attributes) =>
			attributes[TEMPLATE_VALUE] ? { [TEMPLATE_VALUE]: attributes[TEMPLATE_VALUE] } : {},
	},
};

export const SIGNATURE_VALUE_ATTRIBUTE = {
	[SIGNATURE_VALUE]: {
		default: null,
		parseHTML: (element) => element.getAttribute(SIGNATURE_VALUE),
		renderHTML: (attributes) =>
			attributes[SIGNATURE_VALUE] ? { [SIGNATURE_VALUE]: attributes[SIGNATURE_VALUE] } : {},
	},
};

export const getAttrs = (element) => {
	const customAttr = element.getAttribute(TEMPLATE_VALUE);
	return {
		[TEMPLATE_VALUE]: customAttr,
	};
};

export const hasTemplateValue = (node) => {
	return node?.attrs?.[TEMPLATE_VALUE] ?? node?.attrs?.templateValue ?? false;
};

export const renderTemplateAttrs = (templateValue) => {
	if (!templateValue) return;

	const match = FIELDS.find((f) => templateValue.endsWith(f.value));
	const remainder = templateValue.split('.');
	let type = remainder[0];
	type = type === CLIENT_INSIGHT ? CLIENT : type;
	const spacedString = remainder[remainder.length - 1].replace(/([A-Z])/g, ' $1');
	const label = match?.label ?? `${spacedString[0].toUpperCase() + spacedString.slice(1)}`;

	const typeString = `${type[0].toUpperCase() + type.slice(1)}`;

	const fullLabel = `${typeString}: ${label}`;

	return { '--template-tooltip-label': `"${fullLabel}"` };
};

export const removeTemplateMarks = (marks = []) =>
	marks.filter((mark) => !mark?.attrs?.[TEMPLATE_VALUE]);

export const renderHTMLAttrs = ({ HTMLAttributes, editor }) => {
	const hasTemplate = !!HTMLAttributes[TEMPLATE_VALUE];

	const existingStyleObj =
		typeof HTMLAttributes.style === 'string'
			? parseStyleString(HTMLAttributes.style)
			: (HTMLAttributes.style ?? {});

	const styles = {
		...existingStyleObj,
		...renderTemplateAttrs(HTMLAttributes[TEMPLATE_VALUE]),
	};

	const editorConfig = editor?.storage?.config?.editor ?? {};

	let editable = true;
	if (typeof editorConfig.editable === 'function') {
		editable = editorConfig.editable(HTMLAttributes);
	} else if (editorConfig.editable === false) {
		editable = false;
	}

	const chipStyle = editable ? `${TEMPLATE_VALUE}-editable-chip` : `${TEMPLATE_VALUE}-chip`;

	const attrs = {
		...HTMLAttributes,
		// if template-value is present:
		...(hasTemplate && {
			// ...(!editable && { contenteditable: 'false' }),
			...(!editable && { 'data-readonly': 'true' }),
			class: `${HTMLAttributes.class ?? ''} ${chipStyle}`.trim(),
			style: styleToString(styles),
		}),
	};
	return attrs;
};
